/* eslint-disable */
import React from 'react';
import ProgramTable from '../../components/pageComponents/dashboard/coach/ProgramTable';
import styles from './CoachProgramsSection.module.css';
import { useCourseCatalog } from '../../hooks/useCourse';
import { EyeIcon, UploadIcon } from '../../components/common/Icons';
import { useNavigate } from 'react-router-dom';
import ProgramCard from '../../components/pageComponents/dashboard/coach/ProgramCard';
import { useLearnerProfilePrograms } from '../../hooks/useCourse';

interface Enrollment {
	id: number;
	sessionName: string;
	resources: number;
	sessions: string;
	completionRate: number;
}
interface Props {
	learnerId: string;
}

type Column<T> = {
	header: string;
	key: keyof T | 'actions' | 'progress';
	render?: (item: T) => React.ReactNode;
	optional?: boolean;
};

// const LearnerEnrollmentsSection: React.FC = () =>
const LearnerEnrollmentsSection: React.FC<Props> = ({ learnerId }) => {
	const { programs, isLoading, error } = useLearnerProfilePrograms(learnerId);
	const navigate = useNavigate();
	const handleViewProgram = (id: number) => {
		navigate(`/dashboard/programs/${id}`);
	};
	const data =
		programs?.map((program: any) => {
			const totalSessions = program.totalsessions || 0;
			const completedSessions = program.completedsessions || 0;

			// const completionRate = program.completionrate || 0;
			const completionRate =
    totalSessions > 0
        ? Math.round((completedSessions / totalSessions) * 100)
        : 0;

			return {
				id: program.id,
				sessionName: program.title,
				resources: program.totalresources || 0,
				sessions: `${completedSessions}/${totalSessions}`,
				completionRate,

				
			};
		}) || [];
	// ✅ Columns for learner table
	const columns: Column<Enrollment>[] = [
		{ header: 'Recent Sessions', key: 'sessionName' },
		{ header: 'Resources', key: 'resources' },
		{ header: 'Sessions', key: 'sessions' },

		{
			header: 'Completion Rate',
			key: 'progress',
			render: (item: Enrollment) => (
				<div className={styles.progressWrapper}>
					<div className={styles.progressBar}>
						<div
							className={styles.progressFill}
							style={{ width: `${item.completionRate}%` }}
						/>
					</div>
					
				</div>
			),
		},

		{
			header: 'Quick Actions',
			key: 'actions',
			render: (item: Enrollment) => (
				<div className={styles.actions}>
					<button onClick={() => handleViewProgram(item.id)}>
						<EyeIcon />
					</button>

					
				</div>
			),
			optional: true,
		},
	];

	return (
		
		<>
			<div className={styles.container}>
				{/* ✅ DESKTOP TABLE */}
				<div className={styles.desktopOnly}>
					<ProgramTable
						title="Recent Enrollments"
						data={data}
						columns={columns}
						itemsPerPage={4}
					/>
				</div>

				{/* ✅ MOBILE CARDS */}
				<div className={styles.mobileOnly}>
					<h3 className={styles.mobileSectionTitle}>
						Recent Enrollments
					</h3>

					<div className={styles.cardList}>
						{data.map((item: Enrollment) => (
							<ProgramCard
								key={item.id}
								programName={item.sessionName}
								completionValue={item.completionRate}
								viewIcon={<EyeIcon />}
								onViewClick={() => handleViewProgram(item.id)}
								stats={[
									{
										label: 'Resources',
										value: item.resources,
									},
									{ label: 'Sessions', value: item.sessions },
								]}
							/>
						))}
					</div>
				</div>
			</div>
		</>
	);
};

export default LearnerEnrollmentsSection;
